import localForage from 'localforage';

export default class StateCacheService {
	private localForage: typeof localForage;

	public constructor(storeName: string = 'keyvaluepairs') {
		this.localForage = localForage.createInstance({
			name: 'jbm-sales-app',
			storeName
		});
	}

	/**
	 * Alias for clear
	 */
	public flush(): Promise<void> {
		return this.clear();
	}

	public save<T>(key: string, value: T): Promise<T> {
		return this.localForage.setItem(key, value);
	}

	public restore(key: string): Promise<any> {
		return this.localForage.getItem(key);
	}

	public keys(): Promise<string[]> {
		return this.localForage.keys();
	}

	public clear(): Promise<void> {
		return this.localForage.clear();
	}

	public remove(key: string): Promise<void> {
		return this.localForage.removeItem(key);
	}
}
